export enum SHORTCUTS {
    /**
     * @value Arrow Keys
     * @description Label to describe the "Arrow keys" keys of a keyboard (left / up / right /down)
     *
     */
    ARROW_KEYS = 'SHORTCUTS.ARROW_KEYS',
    /**
     * @value Arrow Down
     * @description Label for the "Arrow down" keyboard icon
     */
    DOWN_ARROW_LABEL = 'SHORTCUTS.DOWN_ARROW_LABEL',
    /**
     * @value Enter
     * @description Label for the "Enter" keyboard icon
     */
    ENTER_LABEL = 'SHORTCUTS.ENTER_LABEL',
    /**
     * @value Arrow left
     * @description Label for the "Arrow left" keyboard icon
     */
    LEFT_ARROW_LABEL = 'SHORTCUTS.LEFT_ARROW_LABEL',
    /**
     * @value Arrow right
     * @description Label for the "Arrow right" keyboard icon
     */
    RIGHT_ARROW_LABEL = 'SHORTCUTS.RIGHT_ARROW_LABEL',
    /**
     * @value Arrow up
     * @description Label for the "Arrow up" keyboard icon
     */
    UP_ARROW_LABEL = 'SHORTCUTS.UP_ARROW_LABEL',
}
